import React from "react";

import destination_1 from "../../public/wheretogo-jeseniky/rejviz/destination_1.png";
import destination_2 from "../../public/wheretogo-jeseniky/rejviz/destination_2.png";
import destination_3 from "../../public/wheretogo-jeseniky/rejviz/destination_3.png";
import destination_4 from "../../public/wheretogo-jeseniky/rejviz/destination_4.png";
import destination_5 from "../../public/wheretogo-jeseniky/rejviz/destination_5.png";

import destinationIcon_1 from "../../public/wheretogo-jeseniky/rejviz/icon_1.png";
import destinationIcon_2 from "../../public/wheretogo-jeseniky/rejviz/icon_2.png";
import destinationIcon_3 from "../../public/wheretogo-jeseniky/rejviz/icon_3.png";
import destinationIcon_4 from "../../public/wheretogo-jeseniky/rejviz/icon_4.png";

import { useContext } from "react";
import { DarkModeContext } from "../../components/DarkModeProvider";

const Rejviz = () => {
  const { darkMode } = useContext(DarkModeContext);

  return (
    <>
      <section className={`destinations ${darkMode ? "dark" : "light"}`}>
        <div className="container">
          <div className="destinations__container">
            <img src={destination_1} alt="" />
            <h1>Rejvíz</h1>
            <p>
              O Rejvízu se často mluví jako o nejkrásnějším místě v Jeseníkách.
              U penzionu Rejvíz začíná stejnojmenná naučná stezka, která po
              lesních cestách a pohodlných dřevěných chodníčcích vede do středu
              rozsáhlého rašeliniště a k Mechovému jezírku
            </p>
          </div>
        </div>
      </section>

      <section className={`destinations__icons ${darkMode ? "dark" : "light"}`}>
        <div className="container">
          <div className="destinations__icons--container">
            <div className="destinations__icon">
              <img src={destinationIcon_1} alt="" />
              <p>naučná stezka</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_2} alt="" />
              <p>restaurace</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_3} alt="" />
              <p>rašeliniště</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_4} alt="" />
              <p>vstup 30kč</p>
            </div>
          </div>
        </div>
      </section>

      <section
        className={`destinations__attractions ${darkMode ? "dark" : "light"}`}
      >
        <div className="container">
          <div className="destinations__attractions--container">
            <div className="destinations__attractions--image">
              <img className="destination_1" src={destination_2} alt="" />
              <img className="destination_2" src={destination_3} alt="" />
              <img className="destination_3" src={destination_4} alt="" />
              <img className="destination_4" src={destination_5} alt="" />
            </div>
            <div className="destinations__attractions--content">
              <h2>Zajímavosti</h2>
              <ul>
                <li>
                  Státní přírodní rezervace Rejvíz je se svou rozlohou 350 ha
                  největším rašeliništěm Moravy a Slezska.
                </li>
                <li>
                  Rašeliniště vzniklo v době poledové a svůj vzhled si zachovalo
                  díky klimatickým podmínkám - nízké průměrné roční teplotě (5,6
                  stupňů Celsia) a vysokým srážkám (1400 mm ročně).
                </li>
                <li>
                  Závěrečná část naučné stezky vede po povalovém chodníku až k
                  Velkému mechovému jezírku. Je dlouhé 70 m, široké 40 m a
                  hluboké 3 m. Vrstva rašeliny zde dosahuje 2m.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Rejviz;
